import React from 'react'

// Components
import LessonSteps from 'app/views/components/LessonSteps'
import Browser from 'app/views/components/Browser'

// Settings
import settings from 'settings'

const BrowserSkillAreaSamy = props => (
  <div data-test-id="samy-browser-area-component">
    <div className=" hackedu-sidebar-left uk-background-muted" style={{ height: 'calc(100vh - 80px)', width: 'calc(67% - 80px)' }} ref={(ref) => { this.lessonStepContainer = ref }}>
      <LessonSteps
        lessonStepContainerRef={this.lessonStepContainer}
        onClickBack={(stepIndex) => { props.handleClickBack(stepIndex) }}
        onClickCircle={(stepIndex) => { props.handleClickCircle(stepIndex) }}
        onClickDone={(stepIndex) => { props.handleClickDone(stepIndex) }}
        onClickNext={(stepIndex) => { props.handleClickNext(stepIndex) }}
        steps={props.steps}
        hints={props.hints}
        email=""
        title={props.title}
        description={props.description}
        contentId="1040e3e0-6c6b-11e9-92d8-0a0452f0a95c"
        lessonCompletionURL={props.lessonCompletionURL}
        lessonCompletionText={props.lessonCompletionText}
        ecsTaskDefinition={props.ecsTaskDefinition}
        currentProgress={props.currentProgress}
        hasTest={props.hasTest}
        latestCodePassed={props.latestCodePassed}
        latestCodePatchId={props.latestCodePatchId}
        mustPassCodingExercise={props.mustPassCodingExercise}
        contentType="no-proxy"
        userId={props.userId}
        idToken={props.idToken}
        codeSubmissions={[]}
      />


    </div>
    <div className="hackedu-main uk-background-muted" style={{ minHeight: 'calc(100vh - 80px)', width: '67%' }}>
      <div style={{ height: 'calc(100vh - 90px)' }}>
        <hr className="uk-margin-remove" />
        <div
          className="uk-margin-remove uk-padding-remove"
          style={{
            height: '100%',
          }}
        >
          <Browser
            baseUrl={settings.urls.samy}
            tabs={props.tabs}
            onSandboxSetPath={() => {}}
            contentType="no-proxy"
            compiling={false}
          />
        </div>
      </div>
    </div>
  </div>
)

export default BrowserSkillAreaSamy
